import React from 'react';
import { Form, Radio } from 'semantic-ui-react';

interface Props {
    input: {
        onChange: Function;
        value: boolean;
    };
    fluid?: boolean;
    value: any;
}

export default function RenderRadio(props: Props): React.ReactElement {
    const { fluid, input } = props;

    return (
        <Form.Field >
            <Radio
                {...props}
                {...input as any}
                style={
                    fluid && {
                        display: 'block'
                    }
                }
            />
        </Form.Field>
    );
}
